// UserByUserId.js
'use client';
import { connect } from 'react-redux';

import withRouter from '../component/WithRouter.jsx';
import UserByUserId from '../page/UserByUserId.jsx';

import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { USER_PROFILE_TABS } from '../RemoteConfigKeys.js';

import { ProfileListPublishStatus } from '../resource/profileConstants.js';

const mapStateToProps = (
  state,
  {
    match,
    userId: propsUserId,
    listType: propsListType,
    publishStatus: propsPublishStatus,
  }
) => {
  const listType =
    propsListType ||
    match?.params?.listType ||
    getRemoteConfigData(state, USER_PROFILE_TABS)[0];
  const userId = propsUserId || match?.params?.userId;
  const meId = getMeData(state, 'id');
  const isMeProfile = meId && meId === userId;
  const publishStatus =
    propsPublishStatus ||
    match?.params?.publishStatus ||
    ProfileListPublishStatus.PUBLISHED;
  return {
    meId,
    userId,
    listType,
    publishStatus,
    isMeProfile,
  };
};

export default withRouter(connect(mapStateToProps)(UserByUserId));
